import { audio } from '@/audio-singleton';
import { useState } from 'preact/hooks';
import { gameSignals } from '@/bridge/gameSignals';
import { createUiPrefs, type UiPrefs } from '@/lib/ui-prefs';
import { StatsBarsIcon } from './icons';
import { t } from '@/i18n';

export interface StatsIconBadgeProps {
  onOpen: () => void;
  /** Optional: App passes the lifted shared singleton; omitted callers fall back
   *  to a per-instance createUiPrefs(window.localStorage) (unchanged behavior). */
  prefs?: UiPrefs;
}

export function StatsIconBadge({ onOpen, prefs }: StatsIconBadgeProps) {
  const scene = gameSignals.currentScene.value;
  const completed = gameSignals.completedShotCount.value;
  const prefsRef = prefs ?? createUiPrefs(window.localStorage);
  const [seen, setSeen] = useState<boolean>(prefsRef.getStatsOverlaySeen());

  if (scene !== 'PLAY' || completed < 2) return null;

  return (
    <button
      type="button"
      class="fixed top-[calc(env(safe-area-inset-top)+44px+8px)] right-3 z-30 pointer-events-auto bg-white text-[#1a3a5c] rounded-full p-2 shadow-lg"
      aria-label={t('stats.title')}
      onClick={() => {
        audio().play('tap');
        prefsRef.setStatsOverlaySeen(true);
        setSeen(true);
        onOpen();
      }}
    >
      <StatsBarsIcon size={22} />
      {!seen && (
        <span
          data-testid="stats-badge-dot"
          class="absolute top-0 right-0 w-3 h-3 bg-red-500 rounded-full ring-2 ring-white"
          aria-hidden="true"
        />
      )}
    </button>
  );
}
